module.exports = "/brandon-text-medium-v3.woff2";